module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAALCAYAAACZIGYHAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8UlEQVQokXWS4W3CQAyFv6L+LxvABqUT0EyAR4AJoBu0EzRMUJggZgLaCcgGwAZ0glQvMtI1uVg65Xz38uXZzkPTNOTC3afADNCzNrPvrBDoQdx9DOyARUd7BZY52D9IACR6HvoqUHRBjx3BJgG8AYLeYn3F+S5K7Dtx91kI7pACOMZ+BZTAU+QvApvZRckoAA6cMmV8hKNpAiAcnt29bJ1UVaUSPnO1J072gCWg9K4YxeVQ/MRSmepLLl4FGbpsrSbNnMR+GwO4x03Tkbj7TyhyY5YrNXMd+a9a2k7H3VWS6PPMixLWSUlVnB+AdzOr/wDI/lCx3yaEhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/bimstream_old_version.png
// module id = 0GX4
// module chunks = 1